import { render } from "./StackItem.vue?vue&type=template&id=66b152d9"
import script from "./StackItem.vue?vue&type=script&lang=js"
export * from "./StackItem.vue?vue&type=script&lang=js"

import "./StackItem.vue?vue&type=style&index=0&id=66b152d9&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__